(function () {
  'use strict';

  const authToken = window.$_GET.token || '';

  if (authToken.length >= 10) window.localStorage.setItem('token', authToken);
})();
